import { ReactElement, useEffect, useState } from 'react'
import { Table } from 'bd-web-components'
import { monthlyColumns } from '../../../utils/advance-analytics-table'
import Loader from '../../../components/Loader'
import { TitleChart } from './styles'
import { useGetLast6MonthNewAdvanceData } from '../../../hooks/new-advanced-analytics-v2'

type Row = { month: string }

export function sortByMonth<T extends Row>(
  arr: T[],
  order: 'asc' | 'desc' = 'asc'
): T[] {
  const re = /^\d{4}-\d{2}$/
  return [...arr].sort((a, b) => {
    if (!re.test(a.month) || !re.test(b.month))
      throw new Error('month must be yyyy-MM')
    return order === 'asc'
      ? a.month.localeCompare(b.month)
      : b.month.localeCompare(a.month)
  })
}

export function NewAnalyticsTableWeb(): ReactElement {
  const [data, setData] = useState<any>(null)

  const {
    last6MonthNewAdvanceWebData,
    last6MonthNewAdvanceWebDataLoading,
    last6MonthNewAdvanceWebDataError,
  } = useGetLast6MonthNewAdvanceData()

  useEffect(() => {
    if (last6MonthNewAdvanceWebData !== undefined) {
      console.log('web', last6MonthNewAdvanceWebData)
      setData(sortByMonth(last6MonthNewAdvanceWebData, 'desc'))
    }
  }, [
    last6MonthNewAdvanceWebData,
    last6MonthNewAdvanceWebDataLoading,
    last6MonthNewAdvanceWebDataError,
  ])
  return (
    <>
      {data !== null && (
        <>
          <TitleChart>Origem WEB: Ultimos 6 meses </TitleChart>
          <br />
          <Table columns={monthlyColumns('web')} data={data} pageCount={0} />
        </>
      )}
      {last6MonthNewAdvanceWebDataLoading && (
        <div
          style={{
            height: '600px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Loader />
        </div>
      )}
      {last6MonthNewAdvanceWebDataError && !last6MonthNewAdvanceWebDataLoading && (
        <div
          style={{
            height: '600px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          Um erro aconteceu, tente novamente!
        </div>
      )}
    </>
  )
}
